export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: () => import('./pages/Dashboard'),
  },
]
